<template>
  <div class="partners-widget">
    <div class="container">
      <Toolbar
        class="partners-widget__toolbar"
        title-tag="h2"
        color="2"
        title-color="3"
      >
        <template #title>Партнеры</template>
      </Toolbar>

      <div class="partners-widget__wrap">
        <div class="partners-widget__partners">
          <a
            v-for="(partner, index) in partners"
            :key="index"
            :href="partner.url"
            target="_blank"
            rel="noreferrer"
            :title="partner.title"
            class="partners-widget__partner"
          >
            <img
              :src="partner.image"
              :alt="partner.title"
              class="partners-widget__img"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toolbar } from "@/components/ui/toolbar";
import { mapState, mapMutations } from "vuex";
import service from "@/services/site";

export default {
  name: "PartersWidget",
  components: {
    Toolbar
  },
  computed: {
    ...mapState("dictionaries", {
      partners: ({ dictionaries }) => dictionaries.partners
    })
  },
  created() {
    if (!this.partners) this.loadPartners();
  },
  methods: {
    ...mapMutations("dictionaries", ["SET_DICTIONARY"]),
    async loadPartners() {
      const { data, success } = await service.getPartners();
      if (success) {
        this.SET_DICTIONARY({
          dictionaryName: "partners",
          dictionary: data
        });
      }
    }
  }
};
</script>

<style lang="scss">
.partners-widget {
  padding: 35px 0 5px;
  min-height: 355px;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
  margin-bottom: 30px;

  &__wrap {
    margin-top: 20px;
    padding: 40px;
    background-color: colors(palette-1);
  }

  &__partners {
    display: flex;
    margin: -10px;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  &__partner {
    margin: 15px;
  }

  &__img {
    max-width: 260px;
    max-height: 102px;
  }

  @include breakpoint("md-and-down") {
    &__img {
      max-width: 160px;
      max-height: 60;
    }
  }

  @include breakpoint("sm-and-down") {
    &__partners {
      justify-content: center;
    }
    &__title {
      text-align: center;
    }
  }

  @include breakpoint("xs-only") {
    &__img {
      max-width: 160px;
      max-height: 60;
    }
  }
}
</style>
